import { useSearchParams } from "react-router-dom";
import { ExternalApprovalLogoScreen } from "./ExternalApprovalLogoScreen";
import { ExternalApprovalDesignScreen } from "./ExternalApprovalDesignScreen";

export function MultiApprovalRouter() {
  const [searchParams] = useSearchParams();
  const type = searchParams.get("type");
  const keys = searchParams.get("keys");

  // Validate that we have the required parameters
  if (!type || !keys) {
    return (
      <>
        <h2>Invalid Approval Link</h2>
        <p>Missing required parameters: type and keys</p>
      </>
    );
  }

  // Route to the appropriate approval screen based on type
  if (type === "logos" || type === "logo") {
    return <ExternalApprovalLogoScreen />;
  }
  
  if (type === "designs" || type === "design") {
    return <ExternalApprovalDesignScreen />;
  }

  // Unknown type
  return (
    <>
      <h2>Invalid Approval Type</h2>
      <p>Unknown approval type: {type}</p>
      <p>Supported types: logos, designs</p>
    </>
  );
}